var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    'reports-dashboard-metric': true,
    'is-secondary': _vm.small,
  },style:({
    color: `var(--${_vm.color})`,
  })},[_c('div',{staticClass:"amount"},[(_vm.prefix)?_c('span',[_vm._v(_vm._s(_vm.prefix))]):_vm._e(),(_vm.format === 'currency')?_c('hl-Currency',{attrs:{"amount":_vm.value}}):(_vm.format === 'percent')?_c('span',[_vm._v(_vm._s(_vm.value)+"%")]):_c('span',[_vm._v(_vm._s(_vm.value))])],1),_c('div',{staticClass:"legend"},[_vm._v(_vm._s(_vm.legend))])])
}
var staticRenderFns = []

export { render, staticRenderFns }